import {
  ContentControlAntiphishingSection,
  ContentControlApplicationSection,
  ContentControlDataProtectionSection,
  ContentControlNetworkMonitorSection,
  ContentControlTrafficExclusion,
  ContentControlTrafficScan,
  ContentControlWebAccessSection,
  ContentControlWebCategoriesFilterSection,
  GeneralAdvancedScanClientHelloBlockType,
  GeneralAdvancedSettingsScanSsl,
} from '@nirvana/shared/dtos/types/policies/common';

// UI form value format
export interface ContentControlTrafficFormValue {
  uiSettings: {
    general: {
      display: {
        silentMode: {
          showBrowserToolbar: boolean;
        };
      };
      advanced: {
        settings: {
          scanSsl: GeneralAdvancedSettingsScanSsl;
          excludeFinanceDomains: boolean;
          mitm: {
            enabled: boolean;
            processes: string[];
          };
          scanClientHello: {
            enabled: boolean;
            blockType: GeneralAdvancedScanClientHelloBlockType;
          };
          browserSearchAdvisor: boolean;
        };
      };
    };
    contentControl: {
      traffic: {
        enable: boolean;
        enableExclusions: boolean;
        exclusions?: ContentControlTrafficExclusion[];
      };
    };
  };
}

export interface ContentControlDataProtectionFormValue {
  uiSettings: {
    contentControl: {
      antiphishing: ContentControlAntiphishingSection;
      traffic: {
        trafficScan: ContentControlTrafficScan;
      };
    };
  };
}

export interface ContentControlNetworkMonitorFormValue {
  uiSettings: {
    contentControl: {
      networkMonitor: ContentControlNetworkMonitorSection;
    };
  };
}

export interface ContentControlWebFormValue {
  uiSettings: {
    contentControl: {
      webAccess: ContentControlWebAccessSection;
      webCategoriesFilter: ContentControlWebCategoriesFilterSection;
      dataProtection: ContentControlDataProtectionSection;
      application: ContentControlApplicationSection;
    };
  };
}

// additional information
export interface ScheduleListItem {
  _id: string;
  name: string;
}

export interface ContentControlDataProtectionRuleLight {
  name: string;
  status: ContentControlDataProtectionRuleLightStatus;
}

export enum ContentControlDataProtectionRuleLightStatus {
  ENABLED = 1,
  DISABLED = 0,
}

// searchable keywords
export enum ContentControlTrafficSearchableKeywords {
  NetworkProtection = 'NetworkProtection',
  GeneralSettings = 'GeneralSettings',
  InterceptEncryptedTraffic = 'InterceptEncryptedTraffic',
  ScanHttps = 'ScanHttps',
  Additional = 'Additional',
  ScanFtps = 'ScanFtps',
  ScanSsh = 'ScanSsh',
  ScanImaps = 'ScanImaps',
  ScanMapi = 'ScanMapi',
  ScanPop3 = 'ScanPop3',
  ScanSmtp = 'ScanSmtp',
  ExcludeFinanceDomains = 'ExcludeFinanceDomains',
  InterceptTls = 'InterceptTls',
  AccessDenied = 'AccessDenied',
  ResetConnection = 'ResetConnection',
  Exclusions = 'Exclusions',
}

export enum ContentControlDataProtectionSearchableKeywords {
  Antiphishing = 'Antiphishing',
  DefaultAction = 'DefaultAction',
  ProtectionAgainstFraud = 'ProtectionAgainstFraud',
  ProtectionAgainstPhishing = 'ProtectionAgainstPhishing',
  WebTrafficScan = 'WebTrafficScan',
  EmailTrafficScan = 'EmailTrafficScan',
  Pop3 = 'Pop3',
  Smtp = 'Smtp',
  Imap = 'Imap',
  Mapi = 'Mapi',
}

export enum ContentControlNetworkMonitorSearchableKeywords {
  NetworkAttacksDefense = 'NetworkAttacksDefense',
  InspectRdpTraffic = 'InspectRdpTraffic',
  ServerTrafficScan = 'ServerTrafficScan',
  InspectEncryptedDomainControllerTraffic = 'InspectEncryptedDomainControllerTraffic',
  AttCkTechniques = 'AttCkTechniques',
  InitialAccess = 'InitialAccess',
  CredentialAccess = 'CredentialAccess',
  Discovery = 'Discovery',
  LateralMovement = 'LateralMovement',
  Crimeware = 'Crimeware',
  ResetToDefault = 'ResetToDefault',
}

export enum ContentControlWebSearchableKeywords {
  WebAccessControl = 'WebAccessControl',
  Exclusions = 'Exclusions',
  ApplicationBlacklist = 'ApplicationBlacklist',
  DataProtection = 'DataProtection',
}
